export default "__VITE_ASSET__CpdpfTxu__"